exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3lsw-RAkVmX15l1cZEDwTe {\n    overflow: scroll;\n    font-size: 24px;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n}", ""]);

// exports
exports.locals = {
	"errorMsg": "_3lsw-RAkVmX15l1cZEDwTe"
};